import React from 'react';
import { useStore } from '../context/ProductStore';

const CartSidebar = ({ onClose, onCheckout }) => {
  const { cartItems, cartTotal, cartCount, removeFromCart, updateCartQty } = useStore();

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.sidebar} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={S.header}>
          <div>
            <h2 style={S.title}>🛒 Your Cart</h2>
            <p style={S.sub}>{cartCount} item{cartCount !== 1 ? 's' : ''}</p>
          </div>
          <button onClick={onClose} style={S.closeBtn}>✕</button>
        </div>

        {/* Items */}
        <div style={S.items}>
          {cartItems.length === 0 ? (
            <div style={S.empty}>
              <span style={{ fontSize: '48px' }}>🛒</span>
              <p>Your cart is empty</p>
              <p style={S.emptySub}>Browse products and add items to your cart</p>
            </div>
          ) : (
            cartItems.map(item => {
              const price = item.product.isPromo ? item.product.promoPrice : item.product.price;
              return (
                <div key={item.productId} style={S.item}>
                  {/* Image */}
                  <div style={S.itemThumb}>
                    {item.product.image
                      ? <img src={item.product.image} alt={item.product.name} style={S.thumbImg} />
                      : <span style={{ fontSize: '24px' }}>📦</span>
                    }
                  </div>

                  {/* Info */}
                  <div style={S.itemInfo}>
                    <div style={S.itemName}>{item.product.name}</div>
                    <div style={S.itemCat}>{item.product.category}</div>
                    <div style={S.itemPrice}>
                      USD {(price * item.qty).toFixed(2)}
                      {item.product.isPromo && (
                        <span style={S.savedTag}>🔥 Deal</span>
                      )}
                    </div>
                  </div>

                  {/* Qty + Remove */}
                  <div style={S.itemControls}>
                    <div style={S.qtyRow}>
                      <button onClick={() => updateCartQty(item.productId, item.qty - 1)} style={S.qtyBtn}>−</button>
                      <span style={S.qty}>{item.qty}</span>
                      <button onClick={() => updateCartQty(item.productId, item.qty + 1)} style={S.qtyBtn}>+</button>
                    </div>
                    <button onClick={() => removeFromCart(item.productId)} style={S.removeBtn}>🗑️</button>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Footer */}
        {cartItems.length > 0 && (
          <div style={S.footer}>
            <div style={S.totalRow}>
              <span style={S.totalLabel}>Total</span>
              <span style={S.totalValue}>USD {cartTotal.toFixed(2)}</span>
            </div>
            <p style={S.paymentHint}>💳 EcoCash · Swipe · Bank Transfer</p>
            <button onClick={onCheckout} style={S.checkoutBtn}>
              Proceed to Checkout →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const S = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9990,
    backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)',
  },
  sidebar: {
    position: 'absolute', top: 0, right: 0, bottom: 0,
    width: '100%', maxWidth: '420px',
    backgroundColor: '#1a1a1a',
    border: '1px solid rgba(204,0,0,0.2)',
    display: 'flex', flexDirection: 'column',
    boxShadow: '-8px 0 40px rgba(0,0,0,0.5)',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '24px', borderBottom: '1px solid rgba(255,255,255,0.06)',
  },
  title: { fontSize: '20px', fontWeight: '800', color: '#fff', margin: 0 },
  sub: { fontSize: '13px', color: 'rgba(255,255,255,0.4)', margin: '2px 0 0' },
  closeBtn: {
    background: 'rgba(255,255,255,0.08)', border: 'none', color: '#fff',
    width: '34px', height: '34px', borderRadius: '50%', cursor: 'pointer', fontSize: '15px',
  },
  items: { flex: 1, overflowY: 'auto', padding: '16px' },
  empty: {
    height: '100%', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', gap: '10px',
    color: 'rgba(255,255,255,0.4)', textAlign: 'center', paddingTop: '60px',
  },
  emptySub: { fontSize: '13px', color: 'rgba(255,255,255,0.25)' },
  item: {
    display: 'flex', gap: '12px', alignItems: 'center',
    padding: '14px', borderRadius: '12px',
    backgroundColor: '#242424',
    border: '1px solid rgba(255,255,255,0.05)',
    marginBottom: '10px',
  },
  itemThumb: {
    width: '60px', height: '60px', borderRadius: '10px',
    backgroundColor: 'rgba(204,0,0,0.08)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0, overflow: 'hidden',
  },
  thumbImg: { width: '100%', height: '100%', objectFit: 'cover' },
  itemInfo: { flex: 1, display: 'flex', flexDirection: 'column', gap: '3px' },
  itemName: { fontSize: '14px', fontWeight: '700', color: '#fff', lineHeight: 1.3 },
  itemCat: { fontSize: '11px', color: '#CC0000', fontWeight: '600', textTransform: 'uppercase' },
  itemPrice: { fontSize: '15px', fontWeight: '800', color: '#fff', display: 'flex', alignItems: 'center', gap: '6px' },
  savedTag: { fontSize: '11px', backgroundColor: 'rgba(204,0,0,0.2)', color: '#ff6666', padding: '2px 6px', borderRadius: '4px' },
  itemControls: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', flexShrink: 0 },
  qtyRow: { display: 'flex', alignItems: 'center', gap: '8px' },
  qtyBtn: {
    width: '28px', height: '28px', borderRadius: '6px', border: 'none',
    backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff',
    cursor: 'pointer', fontSize: '16px', fontWeight: '700',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  qty: { fontSize: '15px', fontWeight: '700', color: '#fff', minWidth: '20px', textAlign: 'center' },
  removeBtn: {
    background: 'rgba(220,38,38,0.1)', border: 'none',
    borderRadius: '6px', padding: '4px 8px', cursor: 'pointer', fontSize: '14px',
  },
  footer: {
    padding: '20px 24px', borderTop: '1px solid rgba(255,255,255,0.06)',
    display: 'flex', flexDirection: 'column', gap: '12px',
  },
  totalRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  totalLabel: { fontSize: '16px', fontWeight: '700', color: 'rgba(255,255,255,0.7)' },
  totalValue: { fontSize: '24px', fontWeight: '900', color: '#CC0000' },
  paymentHint: { fontSize: '12px', color: 'rgba(255,255,255,0.35)', textAlign: 'center' },
  checkoutBtn: {
    padding: '15px', borderRadius: '12px', border: 'none',
    background: 'linear-gradient(135deg,#CC0000,#990000)',
    color: '#fff', fontWeight: '800', fontSize: '16px', cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(204,0,0,0.35)',
  },
};

export default CartSidebar;
